import script from "./ProjectModalHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectModalHeader.vue?vue&type=script&setup=true&lang=js"

import "./ProjectModalHeader.vue?vue&type=style&index=0&id=3d797a78&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d797a78"]])

export default __exports__